export const Constants = {
  TIERS: {
    FREE: 'Free',
    PRO: 'Pro',
    PRO_PLUS: 'Pro+',
    ENTERPRISE: 'Enterprise',
    TIER_LIST: ['Free', 'Pro', 'Pro+', 'Enterprise'],
  },
  LICENSE_FEATURES: {
    SCL: 'SCL Helpers',
    DASHBOARD: 'Coordinator Dashboard',
    SETTINGS: {
      GENERAL: {
        ALLOW_CUSTOM_DISTRIBUTION_PROFILES: {
          ALLOWED: ['Incredibuild for Make & Build Tools', 'Incredibuild for Microsoft Visual Studio C / C++'],
          NOT_ALLOWED: ['Generic Acceleration'],
        },
      },
    },
    ENTERPRISE_OBSERVABILITY: 'Enterprise Observability',
    EXTERNAL_USER_MANAGEMENT: 'External User Management',
  },
};

// eslint-disable-next-line no-shadow
export enum ResponseStatus {
  // eslint-disable-next-line no-unused-vars
  Ok = 'OK',
  // eslint-disable-next-line no-unused-vars
  Fail = 'fail',
}
